import GoogleMapReact, { ChangeEventValue } from 'google-map-react';
import { useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import NavbarPlaceholder from '../components/NavbarPlaceholder';
import useDeviceSize, { MD_BREAKPOINT } from '../hooks/useDeviceSize';
import EbcSolarApi from '../lib/api';
import useEbcSolarStore from '../store/ebc-solar-store';
import { WidgetState } from '../types/states';

export const PinRoof = () => {
    const { width, height, isMobile } = useDeviceSize();

    const { initialLocation, setSolarData, setState, setAddress, calculateQuotationData } = useEbcSolarStore((state) => ({
        initialLocation: state.initialLocation,
        setSolarData: state.setSolarData,
        setState: state.setState,
        setAddress: state.setAddress,
        calculateQuotationData: state.calculateQuotationData,
    }));

    const [isSubmitting, setSubmitting] = useState<boolean>(false);
    const [formattedAddress, setFormattedAddress] = useState<string>('');
    const [center, setCenter] = useState<any>(null);

    const handleOnChange = async (e: ChangeEventValue) => {
        const { lat, lng } = e.center;
        if (center && center.lat === lat && center.lng === lng) {
            return;
        }

        const reverseGeocode = await EbcSolarApi.queryReverseGeocodeData(lat, lng);
        if (reverseGeocode) {
            const result = reverseGeocode[0];
            const formattedAddress = result?.formatted_address;
            if (formattedAddress) {
                setFormattedAddress(formattedAddress);
                setCenter(e.center);
            }
        } else {
            // Handle error
        }
    };

    const handleSubmit = async () => {
        if (isSubmitting) {
            return;
        }
        setSubmitting(true);

        const latitude = center.lat;
        const longitude = center.lng;

        const solarData = await EbcSolarApi.querySolarBuildingInsights(latitude, longitude);
        if (solarData) {
            setSolarData(solarData);
            // console.log(solarData);
        } else {
            // Handle error
            setSolarData(null);
        }
        setTimeout(() => {
            setAddress(formattedAddress);
            calculateQuotationData();

            setState(WidgetState.CALCULATING_QUOTE);
            setSubmitting(false);
        }, 1500);
    };

    return (
        <div
            style={{
                minWidth: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                background: '#F8F8F8',
            }}
        >
            <NavbarPlaceholder />
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    paddingBottom: '2rem',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        height: isMobile ? height : 0.8 * height,
                        // height: isMobile ? height : '100%',
                        maxWidth: isMobile ? '100%' : width < MD_BREAKPOINT ? '90%' : '1024px',
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        // flexDirection: isMobile ? 'column-reverse' : 'row',
                        marginTop: isMobile ? '0' : '2rem',
                        background: '#FFFFFF',
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                            // height: '75%',
                            // width: isMobile ? '100%' : '67%',
                            // height: isMobile ? '75%' : '500px',
                            display: 'flex',
                            position: 'relative',
                            flex: isMobile ? 1 : 'auto'
                        }}
                    >
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: 'AIzaSyDu4x0ZAPAvVWcNpsJZC_S7becq_1_9Lnk' }}
                            defaultCenter={initialLocation}
                            defaultZoom={19}
                            yesIWantToUseGoogleMapApiInternals
                            
                            options={{
                                mapTypeId: 'satellite',
                                tilt: 0,
                                disableDoubleClickZoom: true,
                                scrollwheel: false,
                                zoomControl: true,
                                panControl: false,
                                mapTypeControl: false,
                                scaleControl: false,
                                rotateControl: false,
                                fullscreenControl: false,
                                streetViewControl: false,
                                gestureHandling: 'greedy',

                            }}
                            onChange={handleOnChange}
                        />
                        <img
                            width={32}
                            src='https://storage.googleapis.com/ebc-solar-quotation-widget/assets/green-dot.png'
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -100%)',
                                zIndex: 999,
                            }}
                        />
                    </div>
                    <div
                        style={{
                            width: '100%',
                            // height: isMobile ? 'auto' : '25%',
                            // width: isMobile ? '100%' : '33%',
                            // height: isMobile ? '25%' : '500px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            padding: '1rem',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '1rem',
                            }}
                        >
                            <h4 style={{ fontSize: '20px', fontWeight: 600 }}>Drag the map to pin your roof</h4>
                            <p style={{ fontSize: '16px' }}>Your address is</p>
                            <p style={{ fontSize: '16px', fontWeight: 500, color: '#26A757' }}>{formattedAddress}</p>
                        </div>
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingTop: isSubmitting ? '0.5rem' : '1rem',
                                paddingBottom: isSubmitting ? '0.5rem' : '1rem',
                                borderRadius: '16px',
                                color: '#FFFFFF',
                                fontSize: '16px',
                                fontWeight: 600,
                                background: '#26A757',
                                cursor: 'pointer',
                            }}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? (
                                <RotatingLines strokeColor='white' strokeWidth='5' animationDuration='1.00' width='34' visible={true} />
                            ) : (
                                <>Continue</>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PinRoof;
